import { render } from "./StoreEditMonthlySalesTargetForm.vue?vue&type=template&id=d6871dfe"
import script from "./StoreEditMonthlySalesTargetForm.vue?vue&type=script&lang=js"
export * from "./StoreEditMonthlySalesTargetForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__